import $ from 'jquery';
import useSetEnv from '@global/composable/useSetEnv';
import useNavigation from '@global/composable/useNavigation';

import useFormInputOrder from '@global/composable/useFormInputOrder';
import useFocusInput from '@global/composable/useFocusInput';
import useFloatLabel from '@global/composable/useFloatLabel';

const { setEnv } = useSetEnv();
const { navGlobal, navMobile, subnavDesktop, navDesktop, subnavMobile, globalSearch } =
  useNavigation();

const { formInputOrder } = useFormInputOrder();
const { focusInput } = useFocusInput();
const { floatLabel } = useFloatLabel();

window.nowEnv = window.nowEnv || {};
window.genquo = window.genquo || {};

genquo.globalConfig = {
  id: 'genquo',
  name: 'genquo',
  devPort: '89',
  host: 'www.genquo.com',
  alertTitle: '提示訊息',
};

genquo.constants = {
  addToCartUrl: '/Shopping/MiniCart/',
  addToCartUrl_Pre: '/Shopping/ReservationMiniCart/',
  todayViewImg: '/Product/DetailByBarcode',
  GetBanners: '/Home/GetBanners', // 取得全域廣告
  todayViewImgType: 'POST',
};

genquo.miniCartConfig = {
  maxBuyAmount: 20,
  mobileNotice: true,
  cartCookieName: 'genquocart',
  preCartCookieName: 'genquoreservationcart',
};

// 每個區塊的預設圖片路徑
genquo.imagePlaceholder = {
  default: '/img/inf_618x788.jpg',
};

function globalCtrl() {
  setEnv.windowReload();

  navGlobal();
  globalSearch('.global-search');

  focusInput('#global-search');
  floatLabel();

  formInputOrder({
    inputArray: ['.subnav--newsletter__input'],
    submitButton: '.subnav--newsletter__btn',
  });
  formInputOrder({
    inputArray: ['.footer__newsletter__txt'],
    submitButton: '#btnNewletter',
  });
  formInputOrder({
    inputArray: ['#account, #username', '#password', '#captchaTxt, #LoginCode'],
    submitButton: '#btnLogin, #btnShoppingLogin',
  });

  // condition
  if (setEnv.myEquipment()) {
    navMobile();
    subnavMobile();
  } else {
    subnavDesktop();
    navDesktop();
  }
  genquo.alertType = 'single';
}

export default globalCtrl;
